// extracted by mini-css-extract-plugin
module.exports = {"QuickInputs":"OffSiteStockingItemQuickInputs_QuickInputs__3eWmZ"};